import { useState } from 'react';

const useTableHandlers = () => {
  const [expandedColumns, setExpandedColumns] = useState<Set<string>>(new Set());

  const initializeExpandedColumns = (initialExpandedColumns: Set<string>) => {
    setExpandedColumns(new Set(initialExpandedColumns));
  };
  const handleColumnExpand = (columnKey: string) => {
    setExpandedColumns((prev) => new Set(prev).add(columnKey));
  };

  const handleColumnCollapse = (columnKey: string) => {
    setExpandedColumns((prev) => {
      const newSet = new Set(prev);
      newSet.delete(columnKey);
      return newSet;
    });
  };

  return {
    expandedColumns,
    handleColumnExpand,
    handleColumnCollapse,
    initializeExpandedColumns,
  };
};

export default useTableHandlers;
